import { Component } from '@angular/core';

@Component({
  selector: 'otw-contact',
  standalone: true,
  imports: [],
  templateUrl: './contact.component.html',
  styles: ``
})
export class ContactComponent {

}
